import { useParseContentForItemSet } from '@exam-management/rich-text-editor';
import { ContentPreviewer } from '@shared/components';
import { useCallback, useEffect, useState } from 'react';

function useParseItemSetContent(content: string, questionGroupId: string) {
  const { parseContentForItemSet } = useParseContentForItemSet({ questionGroupId });
  const [parsedContent, setParsedContent] = useState('');

  const handleParsedImage = useCallback(async () => {
    if (!content) return;

    const parsedContent = await parseContentForItemSet(content);

    setParsedContent(parsedContent);
  }, [content, parseContentForItemSet]);

  useEffect(() => {
    handleParsedImage();
  }, [handleParsedImage]);

  return {
    content: parsedContent,
  };
}

export interface ItemSetContentPreviewerProps {
  content: string;
  itemSetId: string;
}

export default function ItemSetContentPreviewer(props: Readonly<ItemSetContentPreviewerProps>) {
  const { content, itemSetId } = props;
  const { content: parsedContent } = useParseItemSetContent(content, itemSetId);
  return <ContentPreviewer content={parsedContent} />;
}
